import { OpenNewTabTargetType } from "@voltmoney/types";
import { Platform } from "react-native";
import { getAuthHeaders, RegexConfig } from "../../configs/config";
import { ButtonTypeTokens, InputStateToken } from "@voltmoney/schema";
import { ROUTE } from "../../routes";
import sharedPropsService from "../../SharedPropsService";
import SharedPropsService from "../../SharedPropsService";
import { api, StoreKey } from "../../configs/api";
import { getParameters, getParametersFromURL, isEmpty } from "../../configs/utils";
import { GoogleUtmParams, QUERY_PARAMS } from "../../configs/constants";
import { getPlatformName } from "../../configs/uri-config-utils";
let phone = '';
let pan = '';
let clientRefNo = '';
let otpRef = '';
let reqId = '';
let leadId = '';
let acceptTandC = true;
export const onChangeDimension = async (action, _datastore, { hidePopup }) => {
    console.warn("**** onChangeDimension Action Triggered ****", action);
    const widthX = action.payload.width;
    const heightX = action.payload.height;
    const dimensionData = {
        height: heightX,
        width: widthX
    };
    if (Platform.OS === 'web') {
        // const dimensionEvent = new EventEmitter();
        // dimensionEvent.emit('getDimensionMarketing',  {id: 'getDimensionMarketing', data: dimensionData});
        //send message to parent iframe about dimension changes
        window.parent.postMessage({ id: 'getDimensionLeads', data: dimensionData }, '*');
    }
};
export const onChangeInput = async (action, _datastore, { setDatastore }) => {
    console.warn("**** onChangeInput Action Triggered ****", action);
    const widgetId = action.payload.widgetId;
    const panRegex = new RegExp(RegexConfig.PAN);
    const phoneNumberRegex = new RegExp(RegexConfig.NEW_MOBILE);
    let isPanValid = panRegex.test(pan);
    let isPhoneNumberValid = phoneNumberRegex.test(phone);
    switch (widgetId) {
        case 'PhoneInput':
            await setDatastore(action.routeId, 'PhoneInput', {
                state: InputStateToken.DEFAULT
            });
            let isFromPhonepe;
            const url = SharedPropsService?.getURL();
            const params = getParameters(url);
            if (getPlatformName(params).includes("PHONEPE" /* AppPlatform.PHONEPE */)) {
                isFromPhonepe = true;
            }
            else {
                isFromPhonepe = false;
            }
            phone = action.payload.value;
            if (isFromPhonepe) {
                if (phone != '' && phone.length < 10) {
                    await setDatastore(action.routeId, 'PhoneInput', {
                        state: InputStateToken.ERROR
                    });
                    await setDatastore(ROUTE.CHECK_LIMIT_MFC_INIT, "proceedAfterMobileNumber", {
                        type: ButtonTypeTokens.LargeOutline
                    });
                }
                else {
                    await setDatastore(ROUTE.CHECK_LIMIT_MFC_INIT, "proceedAfterMobileNumber", {
                        type: ButtonTypeTokens.LargeFilled
                    });
                }
            }
            else {
                if (phone != '' && phone.length < 10) {
                    await setDatastore(action.routeId, 'PhoneInput', {
                        state: InputStateToken.ERROR
                    });
                }
            }
            break;
        case 'PanInput':
            await setDatastore(action.routeId, 'PanInput', {
                state: InputStateToken.DEFAULT
            });
            await setDatastore(action.routeId, 'CheckLimitMFCInitStack2', {
                hide: false
            });
            pan = action.payload.value;
            isPanValid = panRegex.test(pan);
            if (pan != '' && !isPanValid) {
                await setDatastore(action.routeId, 'PanInput', {
                    state: InputStateToken.ERROR
                });
            }
            if (pan != '') {
                await setDatastore(action.routeId, 'CheckLimitMFCInitStack2', {
                    hide: true
                });
            }
            break;
        case 'radio':
            acceptTandC = action.payload.value;
            break;
        default: break;
    }
    isPanValid = panRegex.test(pan);
    isPhoneNumberValid = phoneNumberRegex.test(phone);
    if (isPanValid && isPhoneNumberValid && acceptTandC) {
        await setDatastore(action.routeId, 'continue', {
            type: ButtonTypeTokens.LargeFilled
        });
    }
    else {
        await setDatastore(action.routeId, 'continue', {
            type: ButtonTypeTokens.LargeOutline
        });
    }
};
export const toggleCTA = async (action, _datastore, { setDatastore }) => {
    console.warn("**** onToggleCTA Action Triggered ****", action);
    const panRegex = new RegExp(RegexConfig.PAN);
    const isPanValid = panRegex.test(pan);
    const phoneNumberRegex = new RegExp(RegexConfig.NEW_MOBILE);
    const isPhoneNumberValid = phoneNumberRegex.test(phone);
    if (isPanValid && isPhoneNumberValid && action.payload.value) {
        // btn active
        await setDatastore(action.routeId, 'continue', {
            type: ButtonTypeTokens.LargeFilled
        });
    }
    else {
        await setDatastore(action.routeId, 'continue', {
            type: ButtonTypeTokens.LargeOutline
        });
    }
};
export const getOTP = async (action, _datastore, { navigateWithClear, network, asyncStorage, setDatastore, instrumentTrack, addUseProperty, navigate, initializeAmplitudeWithDeviceID, }) => {
    console.warn("**** getOTP Action Triggered ****", action);
    const isResend = action?.payload?.isResend === true;
    let refUrl = getParameters(window.location.href);
    let ref = refUrl.ref;
    await sharedPropsService.setCheckLimitInitData({
        pan: pan,
        phoneNumber: phone
    });
    await asyncStorage.set(StoreKey.U_DATA, JSON.stringify({
        pan: pan,
        phoneNumber: phone
    }));
    const panRegex = new RegExp(RegexConfig.PAN);
    const isPanValid = panRegex.test(pan);
    const phoneNumberRegex = new RegExp(RegexConfig.NEW_MOBILE);
    const isPhoneNumberValid = phoneNumberRegex.test(phone);
    if (isPanValid && isPhoneNumberValid && acceptTandC) {
        await setDatastore(action.routeId, 'continue', {
            loading: true
        });
        const urlParams = `${await SharedPropsService.getUrlParams()}`.split("?");
        const requestUrl = `${api.login}${phone}`;
        const params = urlParams ? getParameters(await SharedPropsService.getUrlParams()) : {};
        console.warn("$$$$$$$$$$ PARMAS $$$$$$$$$$", await SharedPropsService.getUrlParams());
        let createUtmObject = {};
        Object.keys(params).forEach((key) => {
            switch (key) {
                case GoogleUtmParams.UTM_CAMPAIGN:
                    createUtmObject = {
                        utmCampaign: params[key],
                        ...createUtmObject
                    };
                    break;
                case GoogleUtmParams.UTM_CONTENT:
                    createUtmObject = {
                        utmContent: params[key],
                        ...createUtmObject
                    };
                    break;
                case GoogleUtmParams.UTM_MEDIUM:
                    createUtmObject = {
                        utmMedium: params[key],
                        ...createUtmObject
                    };
                    break;
                case GoogleUtmParams.UTM_SOURCE:
                    createUtmObject = {
                        utmSource: params[key],
                        ...createUtmObject
                    };
                    break;
                case GoogleUtmParams.UTM_TERM:
                    createUtmObject = {
                        utmTerm: params[key],
                        ...createUtmObject
                    };
                    break;
            }
        });
        const partnerAccountId = await sharedPropsService.getPartnerAccountId();
        const context = await asyncStorage.get(StoreKey.CONTEXT);
        // take source from param, with default as MARKETING_MFC,
        const sourceQuery = await sharedPropsService.getSource();
        const _params = getParametersFromURL();
        const amplitudeDeviceId = _params?.[QUERY_PARAMS.AMPLITUDE_DEVICE_ID];
        const requestId = _params?.[QUERY_PARAMS.REQUEST_ID];
        let registerLeadBody = {
            phoneNumber: phone,
            pan: pan,
            leadTrackingDetails: {
                ...createUtmObject,
                amplitudeDeviceId: amplitudeDeviceId,
                ...requestId && {
                    requestId: requestId
                }
            },
            partnerAccountId: ref,
            source: sourceQuery ? sourceQuery : 'MARKETING_MFC',
        };
        if (context === 'PARTNER' && partnerAccountId && partnerAccountId !== '') {
            registerLeadBody = {
                ...registerLeadBody,
                partnerAccountId: partnerAccountId,
            };
        }
        if (!isEmpty(createUtmObject)) {
            registerLeadBody = {
                ...registerLeadBody,
                leadTrackingDetails: {
                    ...createUtmObject,
                    amplitudeDeviceId: amplitudeDeviceId,
                    ...requestId && {
                        requestId: requestId
                    }
                }
            };
        }
        //@Todo
        //Call the api to get the access token
        // let authKeyResponse;
        // if(!isResend) {
        //     authKeyResponse = await network.post(`${api.GetToken}`, {
        //             app_key: getBuildType() === BUILD_TYPE.BORROWER_STAGING ? "volt-api-uat@voltmoney.in" : "",
        //             app_secret: getBuildType() === BUILD_TYPE.BORROWER_STAGING ? "1b064d8a0ef63426598d621dcef12fc5fd13cfbb": "",
        //         },
        //         {
        //             headers: await getAuthHeaders()
        //         }
        //     )
        // }
        // console.log("authKeyResponse: ", authKeyResponse);
        // if(isResend) {
        // !isResend && asyncStorage.set(StoreKey.PLATFORM_AUTH_TOKEN, authKeyResponse?.data?.auth_token);
        //Call detailedInit API of MFCentral, this will trigger OTP or throw error if customer does not have any portfolio
        // const header = await getAppHeader();
        // header['Authorization'] = `Bearer ${await asyncStorage.get(StoreKey.PLATFORM_AUTH_TOKEN)}`;
        if (!isResend) {
            const registerLeadResponse = await network.post(`${api.RegisterALead}`, registerLeadBody, {
                headers: await getAuthHeaders()
            }, async () => {
                return;
            }, {
                isPartnerPlatform: true,
            });
            if (registerLeadResponse?.status === 200) {
                leadId = registerLeadResponse?.data?.leadId;
                if (!leadId) {
                    await navigate(ROUTE.CHECK_LIMIT_ALERT_MODAL);
                    return;
                }
                const mfCentralInitRequestBody = {
                    leadId: leadId
                };
                const mfCentralInitResponse = await network.post(`${api.MFCentralTriggerOtpV2}`, mfCentralInitRequestBody, {
                    headers: await getAuthHeaders()
                }, async () => { return; }, {
                    isPartnerPlatform: true
                });
                if (context !== 'PARTNER') {
                    instrumentTrack('MFC_CHECK_LIMIT_BUTTON_CLICKED', { pan: pan, phone: phone });
                    addUseProperty('lead_id', leadId);
                    // initializeAmplitudeWithDeviceID(leadId)
                }
                if (mfCentralInitResponse?.status === 200) {
                    const data = mfCentralInitResponse?.data;
                    clientRefNo = data?.clientRefNo;
                    otpRef = data?.otpRef;
                    reqId = data?.reqId;
                    await sharedPropsService.setMfCentralInitResponse({
                        clientRefNo: data?.clientRefNo,
                        otpRef: data?.otpRef,
                        reqId: data?.reqId,
                        leadId: registerLeadResponse?.data?.leadId
                    });
                    await navigateWithClear(ROUTE.CHECK_LIMIT_MFC_OTP, {
                        phoneNumber: phone,
                        clientRefNo: clientRefNo,
                        otpRef: otpRef,
                        reqId: reqId,
                        leadId: leadId
                    });
                    await setDatastore(action.routeId, 'continue', {
                        loading: false
                    });
                }
                else if (mfCentralInitResponse?.response?.status === 400) {
                    if (mfCentralInitResponse?.response?.data?.voltErrorCode === "PORTFOLIO_NOT_FOUND") {
                        await navigateWithClear(ROUTE.CHECK_LIMIT_NO_MF);
                    }
                }
            }
            if (registerLeadResponse?.status === 500) {
                await navigate(ROUTE.CHECK_LIMIT_ALERT_MODAL);
            }
        }
        //this is only for resend scenario
        if (isResend) {
            await setDatastore(ROUTE.CHECK_LIMIT_MFC_OTP, 'OtpInput', {
                state: InputStateToken.DEFAULT,
            });
            const mfCentralInitData = await sharedPropsService.getMfCentralInitResponse();
            const leadId = mfCentralInitData?.leadId;
            const mfCentralInitRequestBody = {
                leadId: leadId
            };
            const mfCentralInitResponse = await network.post(`${api.MFCentralTriggerOtpV2}`, mfCentralInitRequestBody, {
                headers: await getAuthHeaders()
            }, async () => { return; }, {
                isPartnerPlatform: true
            });
            if (mfCentralInitResponse?.status === 200) {
                const data = mfCentralInitResponse?.data;
                clientRefNo = data?.clientRefNo;
                otpRef = data?.otpRef;
                reqId = data?.reqId;
                await sharedPropsService.setMfCentralInitResponse({
                    clientRefNo: data?.clientRefNo,
                    otpRef: data?.otpRef,
                    reqId: data?.reqId,
                    leadId: leadId
                });
            }
            if (mfCentralInitResponse?.status === 500) {
                await navigate(ROUTE.CHECK_LIMIT_ALERT_MODAL);
            }
        }
        await setDatastore(action.routeId, 'continue', {
            loading: false
        });
    }
};
export const goToPrivacy = async (action, _datastore, { hidePopup, openNewTab }) => {
    console.warn("**** goToPrivacy Action Triggered ****", action);
    await openNewTab('https://voltmoney.in/privacy/', OpenNewTabTargetType.blank);
};
